import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StoreSchedule } from '../model/StoreSchedule';
import { RequestResponse } from '../model/dto/RequestResponse';

@Injectable()
export class StoreScheduleFacade {
  private _urlBase: string;
  private _httpClient: HttpClient;

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this._urlBase = baseUrl;
    this._httpClient = http;
  }

  GetSchedule(typeSchedule: number): Observable<any> {
    return this._httpClient.get<any>(this._urlBase + 'api/StoreSchedule/Schedule?typeSchedule=' + typeSchedule);
  }

  GetByStore(idStore: number): Observable<RequestResponse<StoreSchedule[]>> {
    return this._httpClient.get<any>(this._urlBase + 'api/StoreSchedule/ByStore/' + idStore);
  }

  UpdateStoreSchedule(items: StoreSchedule[]): Observable<RequestResponse<boolean>> {
    return this._httpClient.post<RequestResponse<boolean>>(this._urlBase + 'api/StoreSchedule', items);
  }
}
